import { useQuery } from "@tanstack/react-query";
import { stackCellData } from "../lib/stackClient";
import { polygonAreaM2 } from "../lib/samplingDesign";
import { MODEL_KEY, ACCURACY_PROPS, type AccProp } from "../lib/accuracyIndex";

export interface AccuracyData {
  cellLngLat: { lng: number; lat: number }[];
  model: Partial<Record<AccProp, (number | null)[]>>;
  areaAcres: number;
}

export function useAccuracyData(
  fieldId: string | null | undefined,
  enabled = true,
) {
  return useQuery({
    queryKey: ["accuracy-data", fieldId],
    enabled: enabled && Boolean(fieldId),
    staleTime: 5 * 60_000,
    retry: false,
    queryFn: async (): Promise<AccuracyData> => {
      const cell = await stackCellData(
        fieldId as string,
        ACCURACY_PROPS.map((p) => MODEL_KEY[p]),
      );
      const model: Partial<Record<AccProp, (number | null)[]>> = {};
      ACCURACY_PROPS.forEach((p, i) => {
        model[p] = cell.features[i];
      });
      const areaAcres = cell.geoms.reduce(
        (s, g) => s + polygonAreaM2(g as unknown) / 4046.86,
        0,
      );
      return { cellLngLat: cell.centroids, model, areaAcres };
    },
  });
}
